import zzc from './zzc';
/**
 *  原生预览大图组件
 * @options = {
 * title：标题
 * photos：数组，包含一张张图片信息
 * description：图片描述
 * url：图片链接
 * showIndex：显示index下标
 * }
 *
 * http://wiki.tools.zuzuche.com/pages/viewpage.action?pageId=5515577
*/
const imageViewer = (options) => {
  const {
    title = '',
    showIndex = 0,
    photos = [],
    success = function () {}
  } = options;

  if (photos.length === 0) return;

  zzc.call('base_imageViewer', {
    title,
    showIndex,
    photos,
    success
  });
};

export default imageViewer;
